import { isDefined } from "@clipboard-health/util-ts";
import { differenceInMinutes } from "date-fns";

interface TimesheetTimes {
  clockInTime: Date;
  clockOutTime: Date;
  breakStartTime?: Date;
  breakEndTime?: Date;
}

interface CalculateHasPendingHoursAdjustmentRequest {
  recordedTimesheet: TimesheetTimes;
  adjustedTimesheet: TimesheetTimes;
}

/**
 * Returns true when the adjusted (display) timesheet represents more paid minutes
 * than the recorded (form) timesheet — i.e. the worker has a pending hours adjustment
 * (earlier clock-in, shorter break, or any combination that increases total paid time).
 */
export function calculateHasPendingHoursAdjustment({
  recordedTimesheet,
  adjustedTimesheet,
}: CalculateHasPendingHoursAdjustmentRequest): boolean {
  const recordedBreakMinutes =
    isDefined(recordedTimesheet.breakStartTime) && isDefined(recordedTimesheet.breakEndTime)
      ? differenceInMinutes(recordedTimesheet.breakEndTime, recordedTimesheet.breakStartTime)
      : 0;
  const recordedMinutes =
    differenceInMinutes(recordedTimesheet.clockOutTime, recordedTimesheet.clockInTime) -
    recordedBreakMinutes;

  const adjustedBreakMinutes =
    isDefined(adjustedTimesheet.breakStartTime) && isDefined(adjustedTimesheet.breakEndTime)
      ? differenceInMinutes(adjustedTimesheet.breakEndTime, adjustedTimesheet.breakStartTime)
      : 0;
  const adjustedMinutes =
    differenceInMinutes(adjustedTimesheet.clockOutTime, adjustedTimesheet.clockInTime) -
    adjustedBreakMinutes;

  return adjustedMinutes > recordedMinutes;
}
